import { axiosAuth } from "services/generic/AxiosInterceptor/AxiosInterceptor"

import {
  PhoneCommentRequest,
  PhoneConnectCallRequest,
  PhoneEditAssistantUnavailableRequest,
} from "@shared/dtos/requests/phoneRequests.dto"
import { DeepLinkPatientResponse } from "@shared/dtos/responses/deepLinkResponses.dto"
import {
  PhoneCallResponse,
  PhoneDevicesPerPracticeResponse,
  PhoneMedicationRecordingResponse,
} from "@shared/dtos/responses/phoneResponses.dto"

import { makeFileInstance } from "./generic/FileInstance"

export const getDevicesPerPractice = async (): Promise<PhoneDevicesPerPracticeResponse[]> => {
  return axiosAuth({
    url: "/phone/devices",
    method: "get",
  }).then((resp) => {
    return resp.data
  })
}

export const setAssistantUnavailable = async (
  practiceId: string,
  req: PhoneEditAssistantUnavailableRequest
): Promise<void> => {
  await axiosAuth({
    url: `/phone/assistantunavailable/${practiceId}`,
    method: "patch",
    data: req,
  }).then(() => undefined)
}

export const getArchived = async (
  practiceId: string,
  page: number,
  limit: number,
  search?: string
): Promise<{ data: PhoneCallResponse[]; total: number }> => {
  return axiosAuth({
    url: `/phone/archived/${practiceId}`,
    method: "get",
    params: {
      page,
      limit,
      search,
    },
  }).then((resp) => {
    return resp.data
  })
}

export const archiveCall = async (incomingCallId: string): Promise<void> => {
  return axiosAuth({
    url: `/phone/call/archive/${incomingCallId}`,
    method: "patch",
  }).then(() => undefined)
}

export const unarchiveCall = async (incomingCallId: string): Promise<void> => {
  return axiosAuth({
    url: `/phone/call/unarchive/${incomingCallId}`,
    method: "patch",
  }).then(() => undefined)
}

export const getMedicationRecordings = async (
  practiceId: string,
  archived: boolean
): Promise<PhoneMedicationRecordingResponse[]> => {
  return axiosAuth({
    url: `/phone/medicationrecordings/${practiceId}`,
    method: "get",
    params: {
      archived,
    },
  }).then((resp) => {
    return resp.data
  })
}

export const archiveMedicationRecording = async (medicationRecordingId: string): Promise<void> => {
  return axiosAuth({
    url: `/phone/medicationrecordings/archive/${medicationRecordingId}`,
    method: "patch",
  }).then(() => undefined)
}

export const unarchiveMedicationRecording = async (medicationRecordingId: string): Promise<void> => {
  return axiosAuth({
    url: `/phone/medicationrecordings/unarchive/${medicationRecordingId}`,
    method: "patch",
  }).then(() => undefined)
}

export const downloadMedicationRecording = async (medicationRecordingId: string) => {
  return axiosAuth({
    url: `/phone/medicationrecordings/download/${medicationRecordingId}`,
    method: "get",
    responseType: "blob",
  }).then(makeFileInstance)
}

export const connectCall = async (req: PhoneConnectCallRequest): Promise<void> => {
  await axiosAuth({
    url: `/phone/connectcall`,
    method: "post",
    data: req,
  }).then(() => undefined)
}

export const comment = async (req: PhoneCommentRequest): Promise<void> => {
  await axiosAuth({
    url: `/phone/comment`,
    method: "post",
    data: req,
  }).then(() => undefined)
}

export const searchDeepLinksByPhoneNumber = async (
  practiceId: string,
  phoneNumber: string
): Promise<DeepLinkPatientResponse[]> => {
  return axiosAuth({
    url: `/phone/deeplinks/${practiceId}`,
    method: "get",
    params: { phoneNumber },
  }).then((resp) => resp.data)
}
